<template>
    <div class="library_index">
        <div class="top">
            <el-row>
                <el-col :span="19">
                    <location-selector ref="locSelector" hasProvinceAll hasCityAll @change="listSchoolUserReports()"
                                       v-model="locationArray"></location-selector>
                    <el-select
                        size="medium"
                        v-model="selectBusiness"
                        style="width: 160px;"
                        v-if="!isManageBusiness"
                    >
                        <el-option
                            :label="item.bussinessName"
                            :value="item.bussinessNumber"
                            :key="item.id"
                            v-for="item in businessList"
                        ></el-option>
                    </el-select>
                    <el-select
                        size="medium"
                        v-model="selectCustomer"
                        style="width: 120px;"
                    >
                        <el-option
                            label="全部老师"
                            value="0"
                            key="0"
                        ></el-option>
                        <el-option
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                            v-for="item in customerList"
                        ></el-option>
                    </el-select>
                    <el-select
                        size="medium"
                        v-model="schoolType"
                        style="width: 140px;"
                    >
                        <el-option
                            label="全部学校类型"
                            value="0"
                            key="0"
                        ></el-option>
                        <el-option
                            :label="item.schoolTypeName"
                            :value="item.schoolType"
                            :key="item.schoolType"
                            v-for="item in schoolStagesList"
                        ></el-option>
                    </el-select>
                    <a
                        :href="downLoadHref"
                        target="_blank"
                        download="activityName"
                    >
                        <el-button
                            type="primary"
                            size="medium"
                        >导出
                        </el-button>
                    </a>
                </el-col>
                <el-col :span="5">
                    <el-input
                        placeholder="请输入学校名称"
                        size="medium"
                        icon="el-icon-search"
                        @change="handleInputChange"
                        v-model.trim="query.schoolName"
                    >
                        <el-button
                            slot="append"
                            icon="el-icon-search"
                            @click="handleInputChange"
                        ></el-button>
                    </el-input>
                </el-col>
            </el-row>
        </div>

        <el-table
            stripe
            :data="activityList"
            :height="`${windowHeight - 210}px`"
            border
            style="width: 100%"
        >
            <el-table-column
                label="id"
                width="100"
                align="center"
                prop="schoolId"
            ></el-table-column>
            <el-table-column
                label="学校"
                align="center"
                prop="schoolName"
                width="270"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="教师关注情况"
                align="center"
            >
                <el-table-column
                    label="教师数"
                    align="center"
                    prop="teacherNumber"
                ></el-table-column>
                <el-table-column
                    label="关注数"
                    align="center"
                    prop="teacherFollowNumber"
                ></el-table-column>
                <el-table-column
                    label="关注率"
                    align="center"
                    prop="teacherPercent"
                ></el-table-column>
            </el-table-column>
            <el-table-column
                label="学生关注情况"
                align="center"
            >
                <el-table-column
                    label="学生数"
                    align="center"
                    prop="studentNumber"
                ></el-table-column>
                <el-table-column
                    label="关注数"
                    align="center"
                    prop="studentFollowNumber"
                ></el-table-column>
                <el-table-column
                    label="关注率"
                    align="center"
                    prop="studentPercent"
                ></el-table-column>
            </el-table-column>
            <el-table-column
                label="家长关注情况"
                align="center"
            >
                <el-table-column
                    label="家长数"
                    align="center"
                    prop="parentNumber"
                ></el-table-column>
                <el-table-column
                    label="关注数"
                    align="center"
                    prop="parentFollowNumber"
                ></el-table-column>
                <el-table-column
                    label="关注率"
                    align="center"
                    prop="parentPercent"
                ></el-table-column>
            </el-table-column>
            <el-table-column
                label="等级"
                align="center"
            >
                <template slot-scope="scope">
                    <span>{{scope.row | getLevelScore}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="query.pageNo"
                :page-sizes="[10,20,30, 50]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import {queryBussinessListAll} from "@/api/empower";
    import {
        getSchoolStages,
        isBusinessManager,
        listRoleCustomer,
        listAreaByParentCode,
        listSchoolUserReports,
    } from "@/api/dataAnalysis";
    import mixin from "@/mixins/windowResize";

    export default {
        name: "attentionRateIndex",
        data() {
            return {
                downLoadHref: "",
                locationArray: ['0', '0', '0'],
                selectBusiness: null,
                businessList: [],
                selectCustomer: "0",
                customerList: [],
                schoolType: "0",
                schoolStagesList: [],
                total: null,
                isManageBusiness: false,
                query: {
                    schoolName: "", //书籍名称
                    pageNo: 1, //页数
                    pageSize: 20, //条数
                },
                activityList: [],
            };
        },
        components: {LocationSelector},
        filters: {
            getLevelScore(levelItem) {
                const teacherNum = levelItem.teacherPercent;
                const stuNum = levelItem.studentPercent;
                if (
                    teacherNum &&
                    parseInt(teacherNum.substring(0, teacherNum.length - 1)) >= 90 &&
                    stuNum &&
                    parseInt(stuNum.substring(0, stuNum.length - 1)) >= 90 &&
                    levelItem.schoolActiveCount > 1000
                ) {
                    return "A";
                } else if (
                    teacherNum &&
                    parseInt(teacherNum.substring(0, teacherNum.length - 1)) >= 80 &&
                    stuNum &&
                    parseInt(stuNum.substring(0, stuNum.length - 1)) >= 80
                ) {
                    return "B";
                } else if (levelItem.teacherNumber + levelItem.studentNumber < 10) {
                    return "D";
                } else {
                    return "C";
                }
            },
        },
        watch: {
            selectBusiness() {
                this.listSchoolUserReports();
            },
            selectCustomer() {
                this.listSchoolUserReports();
            },
            schoolType() {
                this.listSchoolUserReports();
            },
        },
        mixins: [mixin],
        //获取渲染数据当数据加载完成后执行(生命周期中的钩子函数)
        created() {
            this.isBusinessManager();
            this.listAreaByParentCode({parentCode: "156"}, "s");
            this.queryBussinessListAll();
            this.listRoleCustomer();
            this.getSchoolStages();
        },
        methods: {
            listAreaByParentCode(query, type) {
                listAreaByParentCode(query).then((data) => {
                    if (data) {
                        const jsCode = data.map((item) => item.code).indexOf("320000");
                        this[`${type}List`] = data;
                        if (type !== "q") {
                            this[`select${type.toUpperCase()}`] =
                                jsCode > -1 ? "320000" : data[0].code;
                        }
                    }
                });
            },
            isBusinessManager() {
                isBusinessManager().then((data) => {
                    if (data.result) {
                        this.isManageBusiness = true;
                    }
                    this.listSchoolUserReports();
                });
            },
            queryBussinessListAll() {
                queryBussinessListAll().then((data) => {
                    if (data.length) {
                        this.businessList = data;
                        this.selectBusiness = data[0].bussinessNumber;
                    }
                });
            },
            listRoleCustomer() {
                listRoleCustomer().then((data) => {
                    if (data.length) {
                        this.customerList = data;
                        // this.selectCustomer = data[0].id;
                    }
                });
            },
            getSchoolStages() {
                getSchoolStages().then((data) => {
                    if (data.length) {
                        this.schoolStagesList = data;
                        // this.schoolType = data[0].schoolType;
                    }
                });
            },
            listSchoolUserReports() {
                let orgAreaCode = this.$refs.locSelector.getCode();

                this.downLoadHref =
                    (global.command === "production"
                        ? "https://wyms.weixiaojia.cn/wyms"
                        : "http://wyms.weixiaojia.net/wyms") +
                    "/schoolReport/exportInfo?areaCode=" +
                    (orgAreaCode == 0 ? '' : orgAreaCode) +
                    "&bussinessNumber=" +
                    (this.isManageBusiness ? "" : this.selectBusiness) +
                    "&userId=" +
                    this.selectCustomer +
                    "&schoolName=" +
                    this.query.schoolName +
                    "&schoolType=" +
                    this.schoolType +
                    "&token=" +
                    this.$store.getters.token;

                const query = {
                    areaCode: orgAreaCode == 0 ? '' : orgAreaCode,
                    bussinessNumber: this.isManageBusiness ? "" : this.selectBusiness,
                    schoolType: this.schoolType,
                    userId: this.selectCustomer,
                };
                listSchoolUserReports(Object.assign(this.query, query)).then((data) => {
                    if (data.dataList.length) {
                        this.activityList = data.dataList;
                        this.total = data.pagination.total;
                    } else {
                        this.activityList = [];
                        this.total = null;
                    }
                });
            },
            handleInputChange() {
                this.query.pageNo = 1;
                this.listSchoolUserReports();
            },
            //切换条数
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.query.pageNo = 1;
                this.listSchoolUserReports();
            },
            //切换页数
            handleCurrentChange() {
                this.listSchoolUserReports();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "./../../styles/mixin";

    .library_index {
        padding: 12px;

        .top {
            padding-bottom: 10px;
        }

        .button {
            padding: 10px 0;

            span {
                cursor: pointer;
                border: 1px solid #dddddd;
                border-radius: 5px;
                text-align: center;
                display: inline-block;
                width: 80px;
                padding: 5px;
                font-size: 14px;
                margin-right: 10px;
            }

            .color {
                background-color: #12b7f5;
                color: #fff;
                border-color: #12b7f5;
            }
        }

        .time-table {
            @include scrollBar;

            .book {
                overflow: hidden;

                .li:hover {
                    i {
                        display: block;
                    }
                }

                .li {
                    position: relative;
                    width: 140px;
                    height: 200px;
                    text-align: center;
                    float: left;
                    margin-right: 37px;
                    margin-bottom: 20px;
                    background: no-repeat center center / cover;
                    /*box-shadow: 0 0 10px #eee;*/

                    i {
                        display: none;
                        font-size: 20px;
                        cursor: pointer;
                    }

                    .el-icon-delete {
                        position: absolute;
                        color: red;
                        right: 5px;
                        top: 5px;
                    }

                    .el-icon-edit {
                        position: absolute;
                        color: #409eff;
                        right: 30px;
                        top: 5px;
                    }

                    .book__info {
                        cursor: pointer;
                        background-color: rgba(0, 0, 0, 0.5);
                        color: #fff;
                        position: absolute;
                        bottom: 0;
                        padding: 2px;
                        width: 100%;

                        div {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/attentionRateIndex.vue